import React from 'react';
import { toMoney } from '../../../utils/common.utils';
import { CleanTransaction } from '../../../export-types/cleaned-types';
import { journals } from '../finance/transactions-history-table.component';

type TransactionItemProps = {
  transaction: CleanTransaction;
};

const descriptions: Record<
  CleanTransaction['type'],
  { [k in CleanTransaction['journal']]?: string }
> = {
  writeOff: {
    paymentForPurchaseOrder: 'Оплата заказа (клиент)',
    expensesForPurchaseOrder: 'Оплата заказа (поставщик)',
    additionalServiceCharge: 'Дополнительные расходы (клиент)',
    additionalServiceChargeExpense: 'Дополнительные расходы (поставщик)',
    additionalPaymentForPurchaseOrder: 'Списание дополнительное (клиент)',
    expensesForDeliveryOrder: 'Оплата доставки (поставщик)',
    paymentForDeliveryOrder: 'Оплата доставки (клиент)',
  },
  refill: {
    refundAdditionalServiceCharge: 'Возврат дополнительных расходов (клиент)',
    refundAdditionalServiceChargeExpense:
      'Возврат дополнительных расходов (поставщик)',
    refundForPurchaseOrder: 'Возврат оплаты (клиент)',
    refundForDeliveryOrder: 'Возврат оплаты (клиент)',
  },
};

export const TransactionItem: React.FC<TransactionItemProps> = ({
  transaction,
}) => {
  const description = React.useMemo(() => {
    if (descriptions[transaction.type][transaction.journal]) {
      return descriptions[transaction.type][transaction.journal];
    }

    return `${journals[transaction.journal]} (${transaction.type} ${transaction.journal})`;
  }, [transaction]);

  return (
    <div className="rounded-8 bg-white px-3 py-2 mb-2">
      <div className="d-flex flex-row justify-content-between align-items-center">
        <div className="me-2">
          <div className="color-gray-400 fs-14 mb-1">
            TxId {transaction.txid}
            {transaction.createdBy?.name
              ? ', ' + transaction.createdBy.name
              : ''}
          </div>
          <div className="color-gray-800 fs-16 fw-500">{description}</div>
        </div>
        <div className="color-gray-800 fs-16 fw-500">
          {toMoney(transaction.amount, transaction.currency)}
        </div>
      </div>
      {transaction.privateComment && (
        <div className="mt-2 bg-gray rounded-8 py-2 px-3">
          {transaction.privateComment}
        </div>
      )}
    </div>
  );
};
